(() => {
  // Storefront browsing has no native drag-and-drop action. Text selection
  // remains available, but dragging that selection must not hand the pointer
  // stream to the browser's native drag session. Covers images, links and text,
  // including dynamically loaded sections. Editable fields retain editing.
  document.addEventListener('dragstart', event => {
    const target = event.target instanceof Element ? event.target : event.target?.parentElement;
    if (target?.closest('input, textarea, [contenteditable="true"]')) return;
    event.preventDefault();
  }, true);
})();
